/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import { connect } from "react-redux";
import BusApiCall from "../../../helper/axios";
import Loader from "../../../component/loader";
import actionTypes from "../../../store/actions";
import React, { Component } from "react";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Axios from "axios";
import Breadcrumb from "../../../component/breadcrumb";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Grid,
  Paper,
  InputLabel,
  Select,
  FormControl,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import Input from "../../../component/inputpm";
import Button from "../../../component/button";
import { Tooltip } from "@mui/material";
import Delete from "@mui/icons-material/Delete";
import { xml2json, json2xml } from "xml-js";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TableContainer from "@mui/material/TableContainer";
class ReceivingRules extends Component {
  // Declare property values that belongs to the component
  state = {
    loading: true,
    bread: [{ title: this.props.t("RECEIVING_RULES"), url: "/receivingRules" }],
    offerings: [],
    ruleRowProxy: [],
    rules: [],
    demographicsOptionsList: [],
    data: {},
    originalData: null,
    editable: false,
    selectedOfferingDialog: false,
    selectedRuleToShow: {},
    selectedRuleOfferings: [],
    selectedRuleIndex: null,
    allWarehouses: [],
  };

  componentDidMount() {
    this.getRulesData();
  }

  getRulesData = () => {
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/product/filters?filterType=quarantineRules`,
    )
      .then((res) => {
        this.setState(
          {
            demographicsOptionsList: res.data.sort((a, b) =>
              a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
            ),
          },
          () => {
            var ruleRowProxy = {};
            for (
              var i = 0;
              i < this.state.demographicsOptionsList.length;
              i++
            ) {
              ruleRowProxy[
                "inputEntry_" +
                  this.state.demographicsOptionsList[i].id +
                  "-operator"
              ] = "==";
              ruleRowProxy[
                "inputEntry_" +
                  this.state.demographicsOptionsList[i].id +
                  "-expression"
              ] = "";
            }
            ruleRowProxy["outputEntry_quarantineWarehouse"] = [];
            ruleRowProxy["outputEntry_ruleName"] = "";
            this.setState({
              ruleRowProxy,
            });
            BusApiCall(
              "GET",
              `${constants.busInternalUrl2}/inventory/quarantineWareHouseRules`,
            )
              .then((res) => {
                if (res.data.code === "200") {
                  var resContent = JSON.parse(atob(res.data.jsonResponse64));
                  var tableContent = JSON.parse(
                    xml2json(atob(resContent.dmnTableContent), {
                      compact: true,
                    }),
                  );
                  this.setState(
                    {
                      originalData: JSON.stringify(tableContent),
                      data: tableContent,
                    },
                    () => {
                      BusApiCall(
                        "GET",
                        `${constants.busInternalUrl2}/inventory/warehouse`,
                      )
                        .then((whRes) => {
                          var allWarehouses = whRes.data;
                          this.setState({
                            allWarehouses,
                          });
                          var demographicsOptionsList = [
                            ...this.state.demographicsOptionsList,
                          ];
                          demographicsOptionsList.push({
                            name: "Warehouse",
                            id: "quarantineWarehouse",
                            entries: allWarehouses,
                            output: true,
                          });
                          var rules = this.state.data.definitions.decision
                            .decisionTable.rule
                            ? this.state.data.definitions.decision.decisionTable
                                .rule
                            : [];
                          var formatedRules = [];
                          if (Array.isArray(rules)) {
                            for (var i = 0; i < rules.length; i++) {
                              var rule = {};
                              var inputs = rules[i].inputEntry;
                              if (Array.isArray(inputs)) {
                                for (var j = 0; j < inputs.length; j++) {
                                  var jid = inputs[j]._attributes.id.substr(
                                    0,
                                    inputs[j]._attributes.id.lastIndexOf("_"),
                                  );
                                  rule[jid + "-operator"] = inputs[
                                    j
                                  ].text._cdata
                                    .split('"')[0]
                                    .trim();
                                  rule[jid + "-expression"] =
                                    inputs[j].text._cdata.split('"')[1] === "-1"
                                      ? ""
                                      : inputs[j].text._cdata.split('"')[1];
                                }
                              } else {
                                if (inputs) {
                                  var jid = inputs._attributes.id.substr(
                                    0,
                                    inputs._attributes.id.lastIndexOf("_"),
                                  );
                                  rule[jid + "-operator"] = inputs.text._cdata
                                    .split('"')[0]
                                    .trim();
                                  rule[jid + "-expression"] =
                                    inputs.text._cdata.split('"')[1] === "-1"
                                      ? ""
                                      : inputs.text._cdata.split('"')[1];
                                }
                              }
                              var outputs = rules[i].outputEntry;
                              if (Array.isArray(outputs)) {
                                for (var k = 0; k < outputs.length; k++) {
                                  if (
                                    outputs[k]._attributes.id.includes(
                                      "quarantineWarehouse",
                                    )
                                  ) {
                                    var kid = outputs[k]._attributes.id.substr(
                                      0,
                                      outputs[k]._attributes.id.lastIndexOf(
                                        "_",
                                      ),
                                    );
                                    // rule[kid] = [];
                                    // rule[kid].push(JSON.parse(outputs[k].text._cdata));
                                    rule[kid] = JSON.parse(
                                      outputs[k].text._cdata,
                                    );
                                  } else {
                                    var kid = outputs[k]._attributes.id.substr(
                                      0,
                                      outputs[k]._attributes.id.lastIndexOf(
                                        "_",
                                      ),
                                    );
                                    rule[kid] = JSON.parse(
                                      outputs[k].text._cdata,
                                    );
                                  }
                                }
                              } else {
                                if (
                                  outputs._attributes.id.includes(
                                    "quarantineWarehouse",
                                  )
                                ) {
                                  var kid = outputs._attributes.id.substr(
                                    0,
                                    outputs._attributes.id.lastIndexOf("_"),
                                  );
                                  // rule[kid] = [];
                                  // rule[kid].push(JSON.parse(outputs.text._cdata));
                                  rule[kid] = JSON.parse(outputs.text._cdata);
                                } else {
                                  var kid = outputs._attributes.id.substr(
                                    0,
                                    outputs._attributes.id.lastIndexOf("_"),
                                  );
                                  rule[kid] = JSON.parse(outputs.text._cdata);
                                }
                              }
                              for (var d in this.state
                                .demographicsOptionsList) {
                                if (
                                  rule.hasOwnProperty(
                                    "inputEntry_" +
                                      this.state.demographicsOptionsList[d].id +
                                      "-operator",
                                  )
                                ) {
                                } else {
                                  rule[
                                    "inputEntry_" +
                                      this.state.demographicsOptionsList[d].id +
                                      "-operator"
                                  ] = "==";
                                }
                                if (
                                  rule.hasOwnProperty(
                                    "inputEntry_" +
                                      this.state.demographicsOptionsList[d].id +
                                      "-expression",
                                  )
                                ) {
                                } else {
                                  rule[
                                    "inputEntry_" +
                                      this.state.demographicsOptionsList[d].id +
                                      "-expression"
                                  ] = "";
                                }
                              }
                              formatedRules.push(rule);
                            }
                          } else {
                            var rule = {};
                            var inputs = rules.inputEntry;
                            if (Array.isArray(inputs)) {
                              for (var j = 0; j < inputs.length; j++) {
                                var jid = inputs[j]._attributes.id.substr(
                                  0,
                                  inputs[j]._attributes.id.lastIndexOf("_"),
                                );
                                rule[jid + "-operator"] = inputs[j].text._cdata
                                  .split('"')[0]
                                  .trim();
                                rule[jid + "-expression"] =
                                  inputs[j].text._cdata.split('"')[1];
                              }
                            } else {
                              var jid = inputs._attributes.id.substr(
                                0,
                                inputs._attributes.id.lastIndexOf("_"),
                              );
                              rule[jid + "-operator"] = inputs.text._cdata
                                .split('"')[0]
                                .trim();
                              rule[jid + "-expression"] =
                                inputs.text._cdata.split('"')[1];
                            }
                            var outputs = rules.outputEntry;
                            for (var k = 0; k < outputs.length; k++) {
                              if (
                                outputs[k]._attributes.id.includes(
                                  "quarantineWarehouse",
                                )
                              ) {
                                var kid = outputs[k]._attributes.id.substr(
                                  0,
                                  outputs[k]._attributes.id.lastIndexOf("_"),
                                );
                                rule[kid] = [];
                                rule[kid].push(
                                  JSON.parse(outputs[k].text._cdata),
                                );
                              } else {
                                var kid = outputs[k]._attributes.id.substr(
                                  0,
                                  outputs[k]._attributes.id.lastIndexOf("_"),
                                );
                                rule[kid] = JSON.parse(outputs[k].text._cdata);
                              }
                            }
                            for (var d in this.state.demographicsOptionsList) {
                              if (
                                rule.hasOwnProperty(
                                  "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-operator",
                                )
                              ) {
                              } else {
                                rule[
                                  "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-operator"
                                ] = "==";
                              }
                              if (
                                rule.hasOwnProperty(
                                  "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-expression",
                                )
                              ) {
                              } else {
                                rule[
                                  "inputEntry_" +
                                    this.state.demographicsOptionsList[d].id +
                                    "-expression"
                                ] = "";
                              }
                            }
                            formatedRules.push(rule);
                          }
                          // const result = [];
                          // for (const obj of formatedRules) {
                          //     let trigger_new = true;
                          //     for (const resObj of result) {
                          //         let trigger_not_equals_keys = true;
                          //         for (const resKey in resObj) for (const key in obj) {
                          //             if (resKey !== "outputEntry_quarantineWarehouse" && key !== "outputEntry_quarantineWarehouse" && resKey !== 'outputEntry_ruleName'
                          //                 && key !== 'outputEntry_ruleName' && resKey === key && resObj[resKey] !== obj[key])
                          //                 trigger_not_equals_keys = false;
                          //         }
                          //         if (trigger_not_equals_keys) {
                          //             trigger_new = false;
                          //             if (Array.isArray(resObj.outputEntry_quarantineWarehouse)) {
                          //                 var index = resObj.outputEntry_quarantineWarehouse.findIndex((x) => x === obj.outputEntry_quarantineWarehouse[0]);
                          //                 if (index === -1) {
                          //                     resObj.outputEntry_quarantineWarehouse.push(obj.outputEntry_quarantineWarehouse[0]);
                          //                 }
                          //             } else {
                          //                 resObj.outputEntry_quarantineWarehouse = [resObj.outputEntry_quarantineWarehouse, obj.outputEntry_quarantineWarehouse]
                          //             };
                          //         }
                          //     }
                          //     if (trigger_new) result.push(obj);
                          // }
                          this.setState(
                            {
                              offerings: allWarehouses,
                              demographicsOptionsList,
                            },
                            () => {
                              this.setState({
                                rules: formatedRules,
                                loading: false,
                              });
                            },
                          );
                        })
                        .catch((err) => {
                          if (
                            err.response &&
                            err.response.data &&
                            err.response.data.message
                          ) {
                            this.props.setErrorMessage(
                              err.response.data.message,
                              false,
                            );
                          } else {
                            this.props.setErrorMessage(
                              this.props.t("DEFAULT_ERROR_MESSAGE"),
                              false,
                            );
                          }
                          this.setState({ loading: false });
                        });
                    },
                  );
                } else {
                  this.setState({ loading: false });
                }
              })
              .catch((err) => {
                var tempData = {
                  definitions: {
                    _attributes: {
                      xmlns: "https://www.omg.org/spec/DMN/20191111/MODEL/",
                      "xmlns:dmndi":
                        "https://www.omg.org/spec/DMN/20191111/DMNDI/",
                      "xmlns:dc": "http://www.omg.org/spec/DMN/20180521/DC/",
                      "xmlns:di": "http://www.omg.org/spec/DMN/20180521/DI/",
                      id: "definition_ac383ec0-59c5-11ed-9c2b-16375c7f68fb",
                      name: "Cumulator Quarantine Rules",
                      namespace: "http://www.flowable.org/dmn",
                      exporter: "Flowable Open Source Modeler",
                      exporterVersion: "6.7.2",
                    },
                    decision: {
                      _attributes: {
                        id: "CumulatorQuarantineRules",
                        name: "Cumulator Quarantine Rules",
                      },
                      description: {
                        _text: "Cumulator Quarantine Rules",
                      },
                      decisionTable: {
                        _attributes: {
                          id: "decisionTable_0d306d80-af44-48ba-81cb-38944fd36c98",
                          hitPolicy: "COLLECT",
                        },
                        input: [],
                        output: [
                          {
                            _attributes: {
                              id: "outputExpression_quarantineWarehouse",
                              label: "Quarantine Warehouse",
                              name: "Quarantine Warehouse",
                              typeRef: "string",
                            },
                            outputValues: {
                              text: {
                                _text: '""',
                              },
                            },
                          },
                          {
                            _attributes: {
                              id: "outputExpression_ruleName",
                              label: "Rule Name",
                              name: "Rule Name",
                              typeRef: "string",
                            },
                            outputValues: {
                              text: {
                                _text: '""',
                              },
                            },
                          },
                        ],
                        rule: [],
                      },
                    },
                    "dmndi:DMNDI": {},
                  },
                };
                BusApiCall(
                  "GET",
                  `${constants.busInternalUrl2}/inventory/warehouse`,
                )
                  .then((whRes) => {
                    var allWarehouses = whRes.data;
                    var demographicsOptionsList = [
                      ...this.state.demographicsOptionsList,
                    ];
                    demographicsOptionsList.push({
                      name: "Quarantine Warehouse",
                      id: "quarantineWarehouse",
                      entries: allWarehouses,
                      output: true,
                    });
                    this.setState({
                      offerings: allWarehouses,
                      demographicsOptionsList,
                      data: tempData,
                      editable: true,
                      loading: false,
                    });
                  })
                  .catch((err) => {
                    if (
                      err.response &&
                      err.response.data &&
                      err.response.data.message
                    ) {
                      this.props.setErrorMessage(
                        err.response.data.message,
                        false,
                      );
                    } else {
                      this.props.setErrorMessage(
                        this.props.t("DEFAULT_ERROR_MESSAGE"),
                        false,
                      );
                    }
                    this.setState({ loading: false });
                  });
              });
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  setInputType = (val) => {
    if (val === "string") {
      return "text";
    } else if (val === "number") {
      return "number";
    } else if (val === "date") {
      return "date";
    } else if (val === "collection") {
      return "text";
    } else {
      return "text";
    }
  };

  createTableData = () => {
    this.setState({
      loading: true,
    });
    var payload = { ...this.state.data };

    var finalInputs = [];
    var demographics = this.state.demographicsOptionsList;
    for (var i = 0; i < demographics.length; i++) {
      if (demographics[i].id !== "quarantineWarehouse") {
        var options = [];
        var ruleInputText = "";
        if (demographics[i].entries) {
          for (var j = 0; j < demographics[i].entries.length; j++) {
            options.push('\"' + demographics[i].entries[j].id + '\"');
          }
        }
        var input = {
          _attributes: {
            label: demographics[i].name,
          },
          inputExpression: {
            _attributes: {
              id: "inputExpression_" + demographics[i].id,
              typeRef: "string",
            },
            text: {
              _text: demographics[i].id,
            },
          },
          inputValues: {
            text: {
              _text: options.join(),
            },
          },
        };
        finalInputs.push(input);
      }
    }

    var tempRules = JSON.parse(JSON.stringify(this.state.rules));
    var finalRules = [];
    var count = 1;
    for (var i = 0; i < tempRules.length; i++) {
      if (!tempRules[i]["outputEntry_ruleName"].trim()) {
        this.props.setErrorMessage(
          this.props.t("RULE_NAME_IS_REQUIRED"),
          false,
        );
        this.setState({
          loading: false,
        });
        return;
      }
      if (
        tempRules[i]["outputEntry_quarantineWarehouse"] &&
        tempRules[i]["outputEntry_quarantineWarehouse"].length > 0
      ) {
        // for (var k = 0; k < tempRules[i]['outputEntry_quarantineWarehouse'].length; k++) {
        var rule = {
          inputEntry: [],
          outputEntry: [],
        };
        for (var j = 0; j < this.state.demographicsOptionsList.length; j++) {
          if (
            this.state.demographicsOptionsList[j].id === "quarantineWarehouse"
          ) {
            rule.outputEntry.push({
              _attributes: { id: "outputEntry_quarantineWarehouse_" + count },
              text: {
                _cdata:
                  '\"' + tempRules[i]["outputEntry_quarantineWarehouse"] + '\"',
              },
            });
          } else {
            if (
              tempRules[i][
                "inputEntry_" +
                  this.state.demographicsOptionsList[j].id +
                  "-expression"
              ]
            ) {
              rule.inputEntry.push({
                _attributes: {
                  id:
                    "inputEntry_" +
                    this.state.demographicsOptionsList[j].id +
                    "_" +
                    count,
                },
                text: {
                  _cdata:
                    "==" +
                    ' \"' +
                    tempRules[i][
                      "inputEntry_" +
                        this.state.demographicsOptionsList[j].id +
                        "-expression"
                    ] +
                    '\"',
                },
              });
            } else {
              if (this.state.demographicsOptionsList[j].entries) {
                rule.inputEntry.push({
                  _attributes: {
                    id:
                      "inputEntry_" +
                      this.state.demographicsOptionsList[j].id +
                      "_" +
                      count,
                  },
                  text: { _cdata: "==" + ' \"' + "-1" + '\"' },
                });
              } else {
                rule.inputEntry.push({
                  _attributes: {
                    id:
                      "inputEntry_" +
                      this.state.demographicsOptionsList[j].id +
                      "_" +
                      count,
                  },
                  text: { _cdata: "==" + ' \"' + "-1" + '\"' },
                });
              }
            }
          }
        }
        rule.outputEntry.push({
          _attributes: { id: "outputEntry_ruleName_" + count },
          text: {
            _cdata: '\"' + tempRules[i]["outputEntry_ruleName"] + '\"',
          },
        });
        count++;
        finalRules.push(rule);
        // }
      } else {
        var rule = {
          inputEntry: [],
          outputEntry: [],
        };
        for (var j = 0; j < this.state.demographicsOptionsList.length; j++) {
          if (
            this.state.demographicsOptionsList[j].id === "quarantineWarehouse"
          ) {
            rule.outputEntry.push({
              _attributes: { id: "outputEntry_quarantineWarehouse_" + count },
              text: { _cdata: '\"\"' },
            });
          } else {
            if (
              tempRules[i][
                "inputEntry_" +
                  this.state.demographicsOptionsList[j].id +
                  "-expression"
              ]
            ) {
              rule.inputEntry.push({
                _attributes: {
                  id:
                    "inputEntry_" +
                    this.state.demographicsOptionsList[j].id +
                    "_" +
                    count,
                },
                text: {
                  _cdata:
                    tempRules[i][
                      "inputEntry_" +
                        this.state.demographicsOptionsList[j].id +
                        "-operator"
                    ] +
                    ' \"' +
                    tempRules[i][
                      "inputEntry_" +
                        this.state.demographicsOptionsList[j].id +
                        "-expression"
                    ] +
                    '\"',
                },
              });
            } else {
              rule.inputEntry.push({
                _attributes: {
                  id:
                    "inputEntry_" +
                    this.state.demographicsOptionsList[j].id +
                    "_" +
                    count,
                },
                text: { _cdata: "==" + ' \"' + "-1" + '\"' },
              });
            }
          }
        }
        rule.outputEntry.push({
          _attributes: { id: "outputEntry_ruleName_" + count },
          text: {
            _cdata: '\"' + tempRules[i]["outputEntry_ruleName"] + '\"',
          },
        });
        count++;
        finalRules.push(rule);
      }
    }
    payload.definitions.decision.decisionTable.input = finalInputs;
    payload.definitions.decision.decisionTable.rule = [...finalRules];
    payload.definitions.decision.decisionTable._attributes.id =
      "decisionTable_0d306d80-af44-48ba-81cb-38944fd36c98";
    this.submitTableData(payload);
  };

  submitTableData = (payload) => {
    var xmlData = json2xml(payload, { compact: true });
    var finalPayload = {
      dmnTableContent: btoa(xmlData),
    };
    BusApiCall(
      "POST",
      `${constants.busInternalUrl2}/inventory/quarantineWareHouseRules`,
      finalPayload,
    )
      .then((res) => {
        this.props.setErrorMessage("Data updated successfully", true);
        this.getRulesData();
        this.setState({
          editable: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  addRule = () => {
    var ruleRowProxy = { ...this.state.ruleRowProxy };
    var rules = JSON.parse(JSON.stringify(this.state.rules));
    rules.push(ruleRowProxy);
    this.setState({
      rules,
    });
  };

  onChangeRule = (e, i, item) => {
    var rules = JSON.parse(JSON.stringify(this.state.rules));
    rules[i][e.target.name] = e.target.value;
    this.setState({
      rules,
    });
  };

  removeRule = (rule, index) => {
    var rules = JSON.parse(JSON.stringify(this.state.rules));
    rules.splice(index, 1);
    this.setState({
      rules,
    });
  };

  changeOfferingSelection = (id) => {
    var rules = JSON.parse(JSON.stringify(this.state.rules));
    var index = rules[this.state.selectedRuleIndex][
      "outputEntry_quarantineWarehouse"
    ].findIndex((x) => x === id);
    if (index > -1) {
      rules[this.state.selectedRuleIndex][
        "outputEntry_quarantineWarehouse"
      ].splice(index, 1);
    } else {
      rules[this.state.selectedRuleIndex][
        "outputEntry_quarantineWarehouse"
      ].push(id);
    }
    this.setState({
      rules,
    });
  };

  editRulesTable = () => {
    this.setState({
      editable: true,
    });
  };

  cancelUpdate = () => {
    this.setState({
      loading: true,
      editable: false,
    });
    this.getRulesData();
  };

  showSelectedOfferings = (rule, list, index) => {
    this.setState({
      selectedOfferingDialog: true,
      selectedRuleToShow: rule,
      selectedRuleOfferings: list ? list : [],
      selectedRuleIndex: index,
    });
  };

  closeShowOfferings = () => {
    this.setState({
      selectedOfferingDialog: false,
      selectedRuleToShow: {},
      selectedRuleOfferings: [],
      selectedRuleIndex: null,
    });
  };

  getWarehouseName = (value) => {
    if (value) {
      var allWarehouses = [...this.state.allWarehouses];
      var index = allWarehouses.findIndex((x) => x.id === value);
      if (index > -1) {
        return allWarehouses[index].name;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ width: "100%", maxWidth: "calc(100% - 70px)" }}>
          <Paper className="tablePaper">
            {this.state.editable ? (
              <div align={"right"} className="global-custom-pagination">
                <Button onClick={() => this.addRule()}>{t("NEW_RULE")}</Button>
              </div>
            ) : (
              <div align={"right"} className="global-custom-pagination">
                <Button onClick={() => this.editRulesTable()}>
                  {t("EDIT")}
                </Button>
              </div>
            )}
            <div style={{ overflow: "auto" }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("RULE_NAME") + " *"}</TableCell>
                      {this.state.demographicsOptionsList.map((item, index) =>
                        item.id === "quarantineWarehouse" ? (
                          <React.Fragment key={index}>
                            <TableCell>{item.name}</TableCell>
                          </React.Fragment>
                        ) : (
                          <React.Fragment key={index}>
                            <TableCell key={index}>{item.name}</TableCell>
                          </React.Fragment>
                        ),
                      )}
                      {this.state.editable && <TableCell></TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.rules &&
                      this.state.rules.map((rule, rIndex) => (
                        <TableRow key={rIndex}>
                          <TableCell>
                            {this.state.editable ? (
                              <Input
                                name={"outputEntry_ruleName"}
                                style={{ width: "175px" }}
                                value={rule["outputEntry_ruleName"]}
                                onChange={(event) =>
                                  this.onChangeRule(event, rIndex)
                                }
                              />
                            ) : (
                              <>{rule["outputEntry_ruleName"]}</>
                            )}
                          </TableCell>
                          {this.state.demographicsOptionsList.map((item) => (
                            <React.Fragment key={item.id}>
                              {this.state.editable ? (
                                <>
                                  {item.output ? (
                                    <TableCell>
                                      {/* <Tooltip title={t('ADD_WAREHOUSE')} onClick={() => this.showSelectedOfferings(rule, rule['outputEntry_' + item.id], rIndex)} style={{ paddingTop: 0, paddingBottom: 0 }}>
                                                                            <AddCircleIcon />
                                                                        </Tooltip> */}
                                      <FormControl
                                        style={{ width: "175px" }}
                                        variant="outlined"
                                        size={"small"}
                                        className={"customeSelectLabel"}
                                      >
                                        <Select
                                          value={rule["outputEntry_" + item.id]}
                                          native
                                          onChange={(event) =>
                                            this.onChangeRule(
                                              event,
                                              rIndex,
                                              item,
                                            )
                                          }
                                          inputProps={{
                                            name: "outputEntry_" + item.id,
                                            id: "outputEntry_" + item.id,
                                          }}
                                        >
                                          {this.state.allWarehouses.map(
                                            (entry, e) => (
                                              <option key={e} value={entry.id}>
                                                {entry.name}
                                              </option>
                                            ),
                                          )}
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                  ) : (
                                    <>
                                      <TableCell>
                                        {item.entries &&
                                        item.entries.length > 0 &&
                                        item.dataType === "collection" ? (
                                          <FormControl
                                            style={{ width: "175px" }}
                                            variant="outlined"
                                            size={"small"}
                                            className={"customeSelectLabel"}
                                          >
                                            <Select
                                              value={
                                                rule[
                                                  "inputEntry_" +
                                                    item.id +
                                                    "-expression"
                                                ]
                                              }
                                              native
                                              onChange={(event) =>
                                                this.onChangeRule(
                                                  event,
                                                  rIndex,
                                                  item,
                                                )
                                              }
                                              inputProps={{
                                                name:
                                                  "inputEntry_" +
                                                  item.id +
                                                  "-expression",
                                                id:
                                                  "inputEntry_" +
                                                  item.id +
                                                  "-expression",
                                              }}
                                            >
                                              {item.entries.map((entry, e) => (
                                                <option
                                                  key={e}
                                                  value={entry.id}
                                                >
                                                  {entry.name}
                                                </option>
                                              ))}
                                            </Select>
                                          </FormControl>
                                        ) : (
                                          <>
                                            <Input
                                              name={
                                                "inputEntry_" +
                                                item.id +
                                                "-expression"
                                              }
                                              id={
                                                "inputEntry_" +
                                                item.id +
                                                "-expression"
                                              }
                                              value={
                                                rule[
                                                  "inputEntry_" +
                                                    item.id +
                                                    "-expression"
                                                ]
                                              }
                                              variant={"outlined"}
                                              onChange={(event) =>
                                                this.onChangeRule(
                                                  event,
                                                  rIndex,
                                                  item,
                                                )
                                              }
                                              // placeholder={t('NAME') + ' *'}
                                              size={"small"}
                                              style={{ width: "175px" }}
                                            />
                                          </>
                                        )}
                                      </TableCell>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {item.output ? (
                                    <TableCell>
                                      {this.getWarehouseName(
                                        rule["outputEntry_" + item.id],
                                      )}
                                    </TableCell>
                                  ) : (
                                    <TableCell>
                                      {item.entries &&
                                      item.entries.length > 0 &&
                                      item.dataType === "collection" ? (
                                        <>
                                          {rule[
                                            "inputEntry_" +
                                              item.id +
                                              "-expression"
                                          ]
                                            ? item.entries.map(
                                                (entry, e) =>
                                                  entry.id ===
                                                    rule[
                                                      "inputEntry_" +
                                                        item.id +
                                                        "-expression"
                                                    ] && entry.name,
                                              )
                                            : "--"}
                                        </>
                                      ) : (
                                        <>
                                          {
                                            rule[
                                              "inputEntry_" +
                                                item.id +
                                                "-expression"
                                            ]
                                          }
                                        </>
                                      )}
                                    </TableCell>
                                  )}
                                </>
                              )}
                            </React.Fragment>
                          ))}
                          {this.state.editable && (
                            <TableCell align="right">
                              <Tooltip title={t("DELETE")}>
                                <Delete
                                  onClick={() => {
                                    this.removeRule(rule, rIndex);
                                  }}
                                />
                              </Tooltip>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    {this.state.rules && this.state.rules.length === 0 && (
                      <TableRow>
                        <TableCell
                          colSpan={
                            this.state.demographicsOptionsList.length + 1
                          }
                          align="center"
                        >
                          {t("NO_RULES_DEFINED")}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            {this.state.editable && (
              <div align={"right"} className="global-custom-pagination">
                <Button onClick={() => this.cancelUpdate()}>
                  {t("CANCEL")}
                </Button>
                <Button
                  style={{ marginLeft: 15 }}
                  onClick={() => this.createTableData()}
                >
                  {t("SAVE")}
                </Button>
              </div>
            )}
          </Paper>

          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    tenantId: state.auth.tenantId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ReceivingRules));
